module.exports = __webpack_public_path__ + "static/media/DiscGuard_Firewall3.3cc6b796.gif";